import { useState } from 'react'

function ActivityTimeline({ events = [] }) {
  const [expanded, setExpanded] = useState(false)

  if (events.length === 0) return null

  return (
    <div className="bg-white rounded-lg overflow-hidden" style={{ border: '1px solid #E2E8F0' }}>
      <button
        onClick={() => setExpanded(!expanded)}
        className="w-full flex items-center justify-between px-5 py-3 hover:bg-gray-50 transition-colors"
      >
        <div className="flex items-center gap-2">
          <span className="text-sm font-semibold" style={{ color: '#0F172A' }}>Recent Advisory Activity</span>
          <span className="text-xs font-medium px-2 py-0.5 rounded-full" style={{ backgroundColor: '#F1F5F9', color: '#64748B' }}>
            {events.length}
          </span>
        </div>
        <svg
          className={`w-4 h-4 transition-transform duration-200 ${expanded ? 'rotate-180' : ''}`}
          style={{ color: '#94A3B8' }}
          fill="none" stroke="currentColor" viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>

      {expanded && (
        <div style={{ borderTop: '1px solid #E2E8F0' }}>
          {events.map(event => (
            <div key={event.id} className="px-5 py-3 flex items-center gap-3" style={{ borderBottom: '1px solid #F1F5F9' }}>
              <div className={`w-2 h-2 rounded-full flex-shrink-0`} style={{ backgroundColor: event.color || '#94A3B8' }} />
              <div className="flex-1 min-w-0">
                <span className="text-sm" style={{ color: '#0F172A' }}>{event.action}</span>
                {event.detail && <span className="text-sm" style={{ color: '#64748B' }}> &mdash; {event.detail}</span>}
              </div>
              <span className="text-xs whitespace-nowrap" style={{ color: '#94A3B8' }}>{event.time}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

export default ActivityTimeline
